var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    (_vm.admin1 || _vm.manager) && _vm.shouldShowNavbar()
      ? _c("header", { staticStyle: { height: "74px" } }, [
          _c(
            "div",
            {
              staticClass: "navbar affix",
              class: { "affix-disabled": _vm.shouldDisableAffix() },
              attrs: {
                id: "navbar-main",
                "data-spy": "affix",
                "data-offset-top": "500",
                role: "navigation",
              },
            },
            [
              _c("div", { staticClass: "container" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "Headblock d-flex justify-content-between align-items-center",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "navbar-header Headblock01 d-flex justify-content-between align-items-center",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-between align-items-center",
                          },
                          [
                            _vm._m(0),
                            _vm._v(" "),
                            _vm.shop
                              ? _c("div", { staticClass: "logoPic" }, [
                                  _vm.shop.Logo
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "logoImgBlock",
                                          attrs: {
                                            title:
                                              "Accueil - " +
                                              _vm.shop.DefaultName,
                                            href: _vm.shop.ShopId,
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.isInAdmin() &&
                                                $event.preventDefault()
                                            },
                                          },
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "img-circle",
                                            attrs: {
                                              width: "125",
                                              height: "125",
                                              src: _vm.UrlService.imagePath(
                                                _vm.shop.ShopId,
                                                _vm.shop.Logo
                                              ),
                                              alt: _vm.shop.DefaultName,
                                            },
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "navbar-brand",
                                      attrs: {
                                        title:
                                          "Accueil - " + _vm.shop.DefaultName,
                                        href: _vm.shop.ShopId,
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.isInAdmin() &&
                                            $event.preventDefault()
                                        },
                                      },
                                    },
                                    [
                                      _vm.isInAdmin()
                                        ? _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                color: "#f5f5f5",
                                                "font-size": "16px",
                                                "font-weight": "normal",
                                              },
                                            },
                                            [_vm._v(_vm._s(_vm.shop.ShopId))]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.shop.DefaultName)),
                                      ]),
                                      _vm._v(" "),
                                      _vm.shop.DefaultDescription &&
                                      !_vm.isInAdmin()
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "restSub text-truncate",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.shop.DefaultDescription
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.isInAdmin()
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "carteMenu",
                                    attrs: { id: "menu-toggle" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.gotoCarteOrToggleSidebar()
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon-eatselfapp_menu-card",
                                    }),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.shop &&
                                            _vm.shop.productTree.product.dn
                                        )
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isInAdmin()
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "carteMenu",
                                    attrs: { id: "menu-toggle" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.gotoAdmin1OrToggleSidebar()
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon-eatselfapp_menu-card",
                                    }),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.shop &&
                                            _vm.shop.productTree.product.dn
                                        )
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isInAdmin()
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "carteMenu",
                                    attrs: { id: "menu-toggle" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.gotoProfileOrToggleSidebar()
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "fa fa-sliders" }),
                                    _c("span", [_vm._v("Paramètres")]),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isInAdmin()
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "p-10",
                                    attrs: { href: "admin2" },
                                  },
                                  [
                                    _c("span", { staticClass: "badge" }, [
                                      _vm._v("bêta"),
                                    ]),
                                    _vm._v(
                                      " Découvrir le nouveau Back-Office\n\t\t\t\t\t\t"
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "Headblock02" }, [
                      _c("ul", [
                        _vm.shop
                          ? _c(
                              "li",
                              {
                                staticClass: "openClose",
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.isInAdmin()
                                  },
                                },
                              },
                              [
                                !_vm.isOpen()
                                  ? _c("div", { staticClass: "closeStatus" }, [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href:
                                              _vm.shop.ShopId +
                                              "/accueil#horaires",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-circle",
                                          }),
                                          _c("span", [_vm._v("Fermé")]),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isOpen()
                                  ? _c("div", { staticClass: "openStatus" }, [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href:
                                              _vm.shop.ShopId +
                                              "/accueil#horaires",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-circle",
                                          }),
                                          _c("span", [_vm._v("Ouvert")]),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isInAdmin() && _vm.shop
                          ? _c("li", { staticClass: "phoneCompany" }, [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "tel:" + _vm.getDiallable(_vm.shop.Tel),
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon-eatselfapp_smartphone",
                                  }),
                                  _c("span", [_vm._v(_vm._s(_vm.shop.Tel))]),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isInAdmin() && _vm.shop && _vm.shop.reservation
                          ? _c("li", { staticClass: "bookingPlace" }, [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.showReservationModal()
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon-eatselfapp_calendar",
                                  }),
                                  _c("span", [_vm._v("Réserver")]),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isInAdmin() && _vm.shop
                          ? _c("li", { staticClass: "countryCompany" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "cursor-pointer",
                                  on: {
                                    click: function ($event) {
                                      return _vm.showGroupList()
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon-eatselfapp_map-pin",
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(_vm.shop.City))]),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              (_vm.shop && _vm.shop.achatActif) ||
                              _vm.isInAdmin(),
                            expression:
                              "shop && shop.achatActif || isInAdmin()",
                          },
                        ],
                        staticClass: "headerRight Headblock03",
                      },
                      [
                        _c("div", { staticClass: "navbar-collapse collapse" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "btn-group notification d-flex justify-content-between align-items-center",
                              staticStyle: { position: "static" },
                            },
                            [
                              !_vm.isInAdmin() && !_vm.client
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "connexion",
                                      on: {
                                        click: function ($event) {
                                          return _vm.showClientLoginModal()
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "icon-eatselfapp_lock",
                                      }),
                                      _c("span", [_vm._v("Connexion")]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isInAdmin() && !_vm.user
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "connexion",
                                      attrs: { href: "admin-login" },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "icon-eatselfapp_lock",
                                      }),
                                      _c("span", [_vm._v("Connexion")]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.isInAdmin() && _vm.client
                                ? _c(
                                    "div",
                                    { staticClass: "btn-group userMenu" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-toggle user",
                                          staticStyle: { margin: "0" },
                                          attrs: { "data-toggle": "dropdown" },
                                        },
                                        [
                                          !_vm.client.hasGravatar
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "avatarLetters",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "first" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.client
                                                            .FirstName[0]
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    { staticClass: "last" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.client.LastName[0]
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.client.hasGravatar
                                            ? _c("img", {
                                                attrs: {
                                                  src:
                                                    "https://www.gravatar.com/avatar/" +
                                                    _vm.gravatar(
                                                      _vm.client.Email
                                                    ) +
                                                    "?s=60",
                                                  alt: _vm.client.Email,
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "Fname" }, [
                                            _vm._v(
                                              _vm._s(_vm.client.FirstName)
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass:
                                              "icon-eatselfapp_caret",
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "ul",
                                        { staticClass: "dropdown-menu p-0" },
                                        [
                                          _c(
                                            "li",
                                            {
                                              staticClass:
                                                "bg-grey3 p-15 radius-18 mb-10",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "fsize-18 text-bold color-grey1 text-capitalize text-truncate mb-5",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.client.FirstName
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.client.LastName
                                                      )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "fsize-12 color-grey2 mb-15",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.client.Email)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "fsize-12 link-2",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.logout()
                                                    },
                                                  },
                                                },
                                                [_vm._v("Déconnexion")]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.shop
                                            ? _c("li", [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        _vm.shop.ShopId +
                                                        "/client/orders",
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fie-icon_receipt",
                                                    }),
                                                    _c("span", [
                                                      _vm._v("Mes Commandes"),
                                                    ]),
                                                  ]
                                                ),
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.shop
                                            ? _c("li", [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        _vm.shop.ShopId +
                                                        "/client/details",
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fie-icon_fingerprint",
                                                    }),
                                                    _c("span", [
                                                      _vm._v("Mon Compte"),
                                                    ]),
                                                  ]
                                                ),
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.shop
                                            ? _c("li", [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        _vm.shop.ShopId +
                                                        "/client/details",
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fie-icon_pin",
                                                    }),
                                                    _c("span", [
                                                      _vm._v("Mes Adresses"),
                                                    ]),
                                                  ]
                                                ),
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.shop
                                            ? _c("li", [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        _vm.shop.ShopId +
                                                        "/client/details",
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fie-icon_credit-card",
                                                    }),
                                                    _c("span", [
                                                      _vm._v("Mes Cartes"),
                                                    ]),
                                                  ]
                                                ),
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.fid_card
                                            ? _c("li", [
                                                _c(
                                                  "a",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.gotoFidCard()
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fie-icon_offer",
                                                    }),
                                                    _c("span", [
                                                      _vm._v("Ma fidélité"),
                                                    ]),
                                                  ]
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isInAdmin() && _vm.user
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "btn-group userMenu",
                                      staticStyle: { position: "static" },
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-toggle user",
                                          staticStyle: { margin: "0" },
                                          attrs: { "data-toggle": "dropdown" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "avatarLetters" },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "first" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.user.UserName &&
                                                        _vm.user.UserName.split(
                                                          " "
                                                        )[0][0]
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "last" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.user.UserName &&
                                                        _vm.user.UserName.split(
                                                          " "
                                                        )[1] &&
                                                        _vm.user.UserName.split(
                                                          " "
                                                        )[1][0]
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "Fname" }, [
                                            _vm._v(_vm._s(_vm.user.UserName)),
                                          ]),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass:
                                              "icon-eatselfapp_caret",
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "ul",
                                        {
                                          staticClass: "dropdown-menu",
                                          staticStyle: {
                                            right: "15px",
                                            top: "100px",
                                            left: "auto",
                                            "z-index": "1001",
                                          },
                                        },
                                        [
                                          _vm._m(1),
                                          _vm._v(" "),
                                          _c("li", [
                                            _c(
                                              "a",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.editOptionGroups()
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "icone icone-lab",
                                                }),
                                                _c("span", [
                                                  _vm._v("Groupes d'options"),
                                                ]),
                                              ]
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _vm._m(2),
                                          _vm._v(" "),
                                          _vm._m(3),
                                          _vm._v(" "),
                                          _c("li", [
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href:
                                                    _vm.user.ShopId +
                                                    "/carte/0",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "icone icone-shop",
                                                }),
                                                _c("span", [
                                                  _vm._v("Passer commande"),
                                                ]),
                                              ]
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _vm._m(4),
                                          _vm._v(" "),
                                          _c("li", [
                                            _c(
                                              "a",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.logoutUser()
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "clyo clyo-disconect",
                                                }),
                                                _c("span", [
                                                  _vm._v("Déconnecter"),
                                                ]),
                                              ]
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.shop
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "btn-group cart",
                                      class: {
                                        "d-flex": !_vm.isInAdmin(),
                                        hidden: _vm.isInAdmin(),
                                      },
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "btn dropdown-toggle align-self-center",
                                          staticStyle: {
                                            background: "none",
                                            "box-shadow": "none",
                                          },
                                          attrs: {
                                            "data-cy": "open-cart",
                                            "data-toggle": "dropdown",
                                            disabled: _vm.shop.achatActif == 0,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.toggleCart()
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fie-icon_takeaway2",
                                          }),
                                          _vm._v(" "),
                                          _vm.nbArticles() !== 0
                                            ? _c(
                                                "span",
                                                { staticClass: "badge" },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.nbArticles())
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: !_vm.isInAdmin(),
                                                  expression: "!isInAdmin()",
                                                },
                                              ],
                                              staticClass: "price",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.prix(_vm.cartTotal())
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "btn-group cmsMenu" }, [
      _c(
        "a",
        {
          staticClass: "cmsToggle",
          attrs: {
            "data-target": "#modalNavigation",
            "data-toggle": "modal",
            href: "",
          },
        },
        [_c("i", { staticClass: "icon-eatselfapp_three-points" })]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c("a", { attrs: { href: "admin1/profile" } }, [
        _c("i", { staticClass: "clyo clyo-gear" }),
        _c("span", [_vm._v("Paramètres")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c("a", { attrs: { href: "admin1/orders" } }, [
        _c("i", { staticClass: "icone icone-new-commande" }),
        _c("span", [_vm._v("Historique des commandes")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c("a", { attrs: { href: "admin1/carte/0" } }, [
        _c("i", { staticClass: "icone icone-editer" }),
        _c("span", [_vm._v("Editer la carte")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c("a", { attrs: { href: "admin1/factures" } }, [
        _c("i", { staticClass: "fa fa-euro" }),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "\n\t\t\t\t\t\t\t\t\t\t\t\tMes factures\n\t\t\t\t\t\t\t\t\t\t\t"
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }